import React, {Component} from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import {renderField, required, positive_float, renderCheckbox} from "../../../utils/formValidations.js";
import { withRouter } from "react-router-dom";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter, Collapse, Alert } from "reactstrap";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import {getStagingConfigs } from "../../../actions/actionStaging";
import {getZones} from "../../../actions/actionZones";
import { getImages } from "../../../actions/actionImage";
import SelectInput from "../../../components/SelectInput";
import { getLicenseStatus} from "../../../actions/actionFooter";

class StagingConfigFormTemplate extends Component {
    constructor (props){
        super(props);
        this.state = {
            currentStaging: {},
            collapseAdvanced: false,
            licensed: false
        };
        this.submitApi = this.submitApi.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.handleCreateError = this.handleCreateError.bind(this);
        this.handleUpdateError = this.handleUpdateError.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
    }

    submitApi(userData) {
        if (this.props.fromUpdate) {
            userData.staging_config_id = this.state.currentStaging && this.state.currentStaging.staging_config_id;
            this.props.updateStagingConfig(userData)
                .then(() => this.handleUpdateSuccess())
                .catch(() => this.handleUpdateError());
        }else {
            this.props.createStagingConfig(userData)
                .then(() => this.handleCreateSuccess())
                .catch(() => this.handleCreateError());
        }
    }

    handleUpdateSuccess(){
        const {updateStagingError} = this.props;
        if(updateStagingError){
            NotificationManager.error(updateStagingError,"Update Staging Config", 3000);
        }
        else{
            NotificationManager.success("Staging Config Updated", "Successfully Updated Staging Config");
            this.props.history.push("/staging");
        }
    }

    handleUpdateError(){
        const {updateStagingError} = this.props;
        if(updateStagingError){
            NotificationManager.error(updateStagingError,"Update Staging Config", 3000);
        } else
            NotificationManager.error("Update Staging Config Failed", "Update Staging Config", 3000);
    }

    handleCreateSuccess(){
        const {createStagingError} = this.props;
        if(createStagingError){
            NotificationManager.error(createStagingError,"Create Staging Config", 3000);
        }
        else{
            NotificationManager.success("Staging Config Created", "Successfully Created Staging Config");
            this.props.history.push("/staging");
        }
    }

    handleCreateError(){
        const {createStagingError} = this.props;
        if(createStagingError){
            NotificationManager.error(createStagingError,"Create Staging Config", 3000);
        } else
            NotificationManager.error("Create Staging Config Failed","Create Staging Config", 3000);
    }

    cancelButton(){
        this.props.history.push("/staging");
    }


    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.staging_configs && nextProps.staging_configs.length > 0 && this.props.staging_configs !== nextProps.staging_configs && this.props.getStagingLoading && this.props.fromUpdate){
            let currentStaging = nextProps.staging_configs.find(staging => staging.staging_config_id === this.props.stagingConfigId);
            this.setState({currentStaging: currentStaging});
            this.props.initialize({
                zone_id: currentStaging.zone_id,
                image_id: currentStaging.image_id,
                num_sessions: currentStaging.num_sessions,
                expiration: currentStaging.expiration,
                allow_kasm_audio: currentStaging.allow_kasm_audio,
                allow_kasm_uploads: currentStaging.allow_kasm_uploads,
                allow_kasm_downloads: currentStaging.allow_kasm_downloads,
                allow_kasm_clipboard_down: currentStaging.allow_kasm_clipboard_down,
                allow_kasm_clipboard_up: currentStaging.allow_kasm_clipboard_up,
                allow_kasm_microphone: currentStaging.allow_kasm_microphone
            });
        }
    }

    componentDidMount() {
        this.props.getZones();
        this.props.getImages();
        if (this.props.fromUpdate) {
            this.props.getStagingConfigs();
        }
        this.props.getLicenseStatus()
            .then(() => {
                const {license_info} = this.props;
                if (license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('session_staging') >= 0 ){
                    this.setState({licensed: true});
                }
            });
    }
    

    render() {
        const {handleSubmit, zones, images, stagingFormValues} = this.props;
        const deny_by_default_checked = false;
        let optionsZones = [];
        zones.map(opt => {
            optionsZones.push({label: opt.zone_name, value: opt.zone_id});
        });
        let optionsImages = [];
        images.map(opt => {
            optionsImages.push({label: opt.friendly_name, value: opt.image_id});
        });

        optionsImages.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);
        optionsZones.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

         if (!this.state.licensed){
            let license_url = `${__LICENSE_INFO_URL__}`;
            return (
                <Alert color="none" isOpen={true}>
                    <h4>Unavailable</h4>
                    This feature must be licensed.
                    <hr />
                    <a href={license_url}>More Information</a><br/>
                </Alert>
            )
        }

        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="zone" className="requiredasterisk">Zone </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="zone_id"
                                       selectedValue={stagingFormValues && stagingFormValues.zone_id ? stagingFormValues.zone_id: ""}
                                       options={optionsZones}
                                       validate={required}
                                       isUpdateForm={this.props.fromUpdate}
                                       component={SelectInput}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="image_friendly_name" className="requiredasterisk">Image </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="image_id"
                                       selectedValue={stagingFormValues && stagingFormValues.image_id ? stagingFormValues.image_id: ""}
                                       options={optionsImages}
                                       validate={required}
                                       isUpdateForm={this.props.fromUpdate}
                                       component={SelectInput}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="num_sessions" className="requiredasterisk">Desired Sessions </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="num_sessions"
                                       id="num_sessions"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="expiration" className="requiredasterisk">Expiration (Hours) </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="number"
                                       name="expiration"
                                       id="expiration"
                                       component={renderField}
                                       validate={[required, positive_float]}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="5">
                                <Label htmlFor="allow_kasm_audio" className="requiredasterisk">Allow Audio </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="allow_kasm_audio"
                                       id="allow_kasm_audio"
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="5">
                                <Label htmlFor="allow_kasm_clipboard_down" className="requiredasterisk">Allow Clipboard Down </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="allow_kasm_clipboard_down"
                                       id="allow_kasm_clipboard_down"
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="5">
                                <Label htmlFor="allow_kasm_clipboard_up" className="requiredasterisk">Allow Clipboard Up </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="allow_kasm_clipboard_up"
                                       id="allow_kasm_clipboard_up"
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="5">
                                <Label htmlFor="allow_kasm_downloads" className="requiredasterisk">Allow Downloads </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="allow_kasm_downloads"
                                       id="allow_kasm_downloads"
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="5">
                                <Label htmlFor="allow_kasm_microphone" className="requiredasterisk">Allow Microphone </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="allow_kasm_microphone"
                                       id="allow_kasm_microphone"
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="5">
                                <Label htmlFor="allow_kasm_uploads" className="requiredasterisk">Allow Uploads </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="allow_kasm_uploads"
                                       id="allow_kasm_uploads"
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>


                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="cancel" size="sm" 
                        className="cancel-button"
                        color="basic" onClick={() => this.cancelButton()}>Cancel</Button>
                        <Button type="submit" size="sm" 
                        className="submit-button"
                        color="primary"> Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

StagingConfigFormTemplate.proptypes = {
    createStagingConfig: Proptypes.func,
    updateStagingConfig: Proptypes.func,
    fromUpdate: Proptypes.bool,
};

let StagingConfigFormWithRouter = withRouter(StagingConfigFormTemplate);


const selector = formValueSelector('StagingConfigForm');

let StagingConfigForm =  connect(state =>{

            const has_categorization_enabled = selector(state, 'enable_categorization');

            return {
                has_categorization_enabled,
                createStagingError: state.staging.createStagingError,
                createStagingLoading: state.staging.createStagingLoading,
                createdStaging: state.staging.createdStaging,
                updateStagingError: state.staging.updateStagingError,
                updateStagingLoading: state.staging.updateStagingLoading,
                updatedStaging: state.staging.updatedStaging,
                staging_configs: state.staging.staging_configs,
                getStagingLoading: state.staging.getStagingLoading || false,
                zones: state.zones.zones || [],
                images: state.images.images || [],
                stagingFormValues: state.form && state.form.StagingConfigForm && state.form.StagingConfigForm.values ? state.form.StagingConfigForm.values : null,
                license_info: state.footer && state.footer.license_info ? state.footer.license_info : null,

            }
    },

    dispatch =>
        ({
            getStagingConfigs: () => dispatch(getStagingConfigs()),
            getZones: () => dispatch(getZones()),
            getImages: () => dispatch(getImages()),
            getLicenseStatus: () => dispatch(getLicenseStatus()),
        }))(StagingConfigFormWithRouter);

export default reduxForm({
    form: "StagingConfigForm",
})(StagingConfigForm);